import React, { Suspense } from "react";

var SafeSuspense = function SafeSuspense(_ref) {
  var children = _ref.children,
      fallback = _ref.fallback;
  var IS_TEST_RUNNER = window.navigator.userAgent.match(/StorybookTestRunner/);
  return IS_TEST_RUNNER ? /*#__PURE__*/React.createElement(React.Fragment, null, fallback) : /*#__PURE__*/React.createElement(Suspense, {
    fallback: fallback
  }, children);
};

export default SafeSuspense;
//# sourceMappingURL=suspense.js.map